import sideContent from './injectSideContent';

export default [...sideContent];
